(function () {
  var timers = new WeakMap();

  function formatRemaining(diffMs) {
    var totalSeconds = Math.max(Math.floor(diffMs / 1000), 0);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var parts = [];
    if (days > 0) parts.push(days + '日');
    parts.push(hours + '時間');
    if (days === 0) parts.push(minutes + '分');
    parts.push(seconds + '秒');
    return parts.join('');
  }

  function updateNode(node) {
    var endAt = node.dataset.endAt;
    if (!endAt) return false;

    var targetTime = Date.parse(endAt);
    if (Number.isNaN(targetTime)) {
      node.textContent = '';
      return false;
    }

    var prefix = node.dataset.prefix || '';
    var completeText = node.dataset.completeText || '終了しました';
    var remaining = targetTime - Date.now();

    if (remaining <= 0) {
      node.textContent = completeText;
      return false;
    }

    node.textContent = prefix ? prefix + 'まで 残り' + formatRemaining(remaining) : '残り' + formatRemaining(remaining);
    return true;
  }

  function bindCountdown(node) {
    if (!(node instanceof HTMLElement)) return;

    var active = updateNode(node);
    var existingTimer = timers.get(node);
    if (existingTimer) {
      window.clearInterval(existingTimer);
      timers.delete(node);
    }

    if (!active) return;

    var timer = window.setInterval(function () {
      if (!updateNode(node)) {
        window.clearInterval(timer);
        timers.delete(node);
      }
    }, 1000);

    timers.set(node, timer);
  }

  function initializeCountdowns(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(bindCountdown);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeCountdowns(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeCountdowns(event.target);
  });
})();
